export const GET_ALL_ROLES = "GET_ALL_ROLES";
export const RESET_DATA = "RESET_DATA";
